import { CRASH_LOG } from '../constant/actionTypes';

const getCrashLogs = (state, action) => {
  switch (action.type) {
    case CRASH_LOG.DATA.INITIATE:
      return { isFetching: true, data: action.payload };
    case CRASH_LOG.DATA.SUCCESS:
      return { isFetching: false, data: action.payload };
    case CRASH_LOG.DATA.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getCrashLogs;
